interface KeyboardEventLike {
  isComposing?: boolean;
  keyCode?: number;
  nativeEvent?: KeyboardEventLike;
}

export const isImeCompositionEvent = (event: KeyboardEventLike) => {
  const nativeEvent = event.nativeEvent || event;

  return nativeEvent.isComposing === true || nativeEvent.keyCode === 229;
};
